// {
//   "name": "iconic-video-gallery.js",
//   "author": "Arham Web Works"
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get('iconic-video-gallery')) {
    return;
  }

  class IconicVideoGallery extends HTMLElement {
    constructor() {
      super();

      this.initAutoplayVideo = this.initAutoplayVideo.bind(this);
    
    }

    connectedCallback() {
      this.initAutoplayVideo(); // Initialize auto-play video click event
    }

    initAutoplayVideo() {

      const Iconicvideos = this.querySelectorAll('video');
      Iconicvideos.forEach(function(video) {
        // Check if the video is autoplaying
        if (video.hasAttribute('autoplay')) {
          // Add a click event listener to the video
          video.addEventListener('click', function() {
            if (!video.paused) {
              video.pause(); // Pause the video if it's playing
            } else {
              video.play(); // Play the video if it's paused
            }
          });
        }
      });
      
      const playButtons = this.querySelectorAll('.iconic-video-play-icon');
      playButtons.forEach((playButton) => {
        playButton.addEventListener('click', () => {
          const videoContainer = playButton.closest('.iconic-video-grid');
  
          const iframe = videoContainer.querySelector('iframe');
          if (iframe) {
            let src = iframe.src;
  
            if (src.includes('youtube.com')) {
              iframe.src = `${src}&autoplay=1`;
            }
  
            if (src.includes('vimeo.com')) {
              iframe.src = `${src}&autoplay=1`;
            }
  
            iframe.addEventListener('click', function () {
              iframe.src = iframe.src.replace('&autoplay=1', ''); // Stop video by removing autoplay
            });
          }
  
          const videoTag = videoContainer.querySelector('video');
          const playIcon = videoContainer.querySelector('.iconic-video-play-button');
          const playIconSticky = videoContainer.querySelector('.iconic-sticky-play-icon');
          
          
          if (videoTag) {
            videoTag.play();
  
            videoTag.addEventListener('click', function () {
              if (!videoTag.paused) {
                console.log('puse');
                videoTag.pause();
                if (playIcon) {
                  playIcon.style.display = 'block';
                }
                if (playIconSticky) {
                  playIconSticky.style.display = 'block';
                }
              } else {
                console.log('play');
                videoTag.play();
                if (playIcon) {
                  playIcon.style.display = 'none';
                }
                if (playIconSticky) {
                  playIconSticky.style.display = 'none';
                }
              }
            });
          }
  
          if (playIcon) {
            playIcon.style.display = 'none';
          }
          if (playIconSticky) {
            playIconSticky.style.display = 'none';
          }
        });
      });
    }
  }

  customElements.define('iconic-video-gallery', IconicVideoGallery);
})();
